@import '../../stylesheets/defaults'

.mp-toast-stage
  display flex
  position relative

.mp-toast-container
  animation ($mp-slow)ms $ease-in-out container-animation both
  box-sizing border-box
  display flex
  opacity 1
  padding 0 0 16px 0
  position relative

.mp-toast-container.mp-toast-out
  animation ($mp-slow)ms $ease-in-out ($mp-slow)ms fade-out-container-animation both

.mp-toast-widget
  align-items center
  background-color var(--inverted-component-background-color)
  border-radius 6px
  box-sizing border-box
  color var(--inverted-component-text-color)
  display flex
  font-family $family-helvetica
  font-size $font-size-medium
  font-weight $weight-bold
  height 44px
  padding 4px
  pointer-events auto
  position relative
  mp-drop-box-shadow()

.icon-container
  align-items center
  border-radius 3px
  box-sizing border-box
  display flex
  height 36px
  justify-content center
  position relative
  width 36px

  &.error
    background-color var(--negative-color)

  &.info
    background-color var(--blue1)

  &.success
    background-color var(--green1)

  &.warning
    background-color var(--orange1)

  &.destructive
    background-color var(--red1)

  &.timeout
    &.destructive
      background-color var(--red2)

    &.error
      background-color var(--red2)

    &.info
      background-color var(--blue2)

    &.success
      background-color var(--green2)

    &.warning
      background-color var(--orange2)

.icon-container-icon
  align-self center
  position relative
  z-index $z-toast + 1
  svg-icon-style-props($white)

.icon-container-animated-fadeout
  animation $ease-in-out timeout-animation both
  background-color var(--blue2)
  border-radius 3px
  height 36px
  left 4px
  position absolute
  transform-origin left
  width 36px

  &.error
    background-color var(--red1)

  &.destructive
    background-color var(--red1)

  &.info
    background-color var(--blue1)

  &.success
    background-color var(--green1)

  &.warning
    background-color var(--orange1)

.mp-toast-body
  align-items center
  animation ($mp-slow)ms $ease-in-out ($mp-slow)ms body-slide-in-animation both
  box-sizing border-box
  display flex
  padding-left 8px
  padding-right 8px

.mp-toast-container.mp-toast-out .mp-toast-body
  animation ($mp-slow)ms $ease-in-out body-slide-out-animation both

.mp-toast-message
  box-sizing border-box
  display flex
  flex-grow 1
  font-family $family-helvetica
  font-size $font-size-medium
  font-weight $weight-medium
  position relative

.mp-toast-actions
  box-sizing border-box
  display flex
  padding 0 16px

  &:empty
    display none

.mp-toast-action
  box-sizing border-box
  cursor pointer
  font-family $family-helvetica
  font-size $font-size-medium
  font-weight $weight-medium
  margin-left 24px
  margin-right 0
  text-transform capitalize

  &:hover
    text-decoration underline

.mp-toast-cta
  color var(--inverted-component-text-color)

.mp-toast-close
  box-sizing border-box
  cursor pointer
  display flex
  flex-direction row-reverse
  padding-left 8px

.mp-toast-close-icon
  svg-icon-style-props('%s' % var(--inverted-component-text-color))

@keyframes body-slide-in-animation
  0%
    display none
    max-width 0
    opacity 0
    padding 0

  50%
    opacity 0

  100%
    display flex
    max-width 1000px
    opacity 1

@keyframes body-slide-out-animation
  0%
    display flex
    max-width 1000px
    opacity 1

  50%
    opacity 0

  100%
    display none
    max-width 0
    opacity 0
    padding 0

@keyframes container-animation
  0%
    opacity 0
    transform scale(0)

  50%
    transform scale(1)

  60%
    transform scale(1.1)

  85%
    transform scale(0.95)

  100%
    opacity 1
    transform scale(1)

@keyframes fade-out-container-animation
  0%
    opacity 1
    transform scale(1)

  15%
    transform scale(0.95)

  40%
    transform scale(1.1)

  50%
    transform scale(1)

  100%
    opacity 0
    transform scale(0)

@keyframes timeout-animation
  0%
    max-width scaleX(1)
  100%
    transform scaleX(0)
